import React, { useState } from "react";
import slider1 from "../../assets/img/slider/slider1.jpg";
import slider2 from "../../assets/img/slider/slider2.jpg";
import slider3 from "../../assets/img/slider/slider3.jpg";
import Slider from "react-slick";

export default function Sliderhome() {

  const home = {
    adaptiveHeight: true,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 900,
    autoplay: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <div style={{ maxWidth: "2380px", margin: "0 auto 0 auto" }}>
        <section id="home" className="slider-area fix p-relative">
          <Slider className="slider-active" {...home}>
            <div>
              <img
                src={slider1}
                alt="img"
                className="slider-img"
              />
            </div>
            <div>
              <img
                src={slider2}
                alt="img"
                className="slider-img position-semi-right"
              />
            </div>
            <div>
              <img
                src={slider3}
                alt="img"
                className="slider-img position-right"
              />
            </div>
          </Slider>
        </section>
      </div>
    </>
  );
}
